import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { useTokens } from 'theme';

import { useTranslation } from 'react-i18next';

/** A run's name — what a customer quotes to support — with a copy button. */
export default function RunRef({ name }) {
  const { t } = useTranslation();
  const themeTokens = useTokens();
  const [copied, setCopied] = useState(false);
  const copy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard
      ?.writeText(name)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      })
      .catch(() => {});
  };
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25 }}>
      <Box component="span" sx={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.7rem', color: themeTokens.iconMuted }}>
        {name}
      </Box>
      <IconButton
        size="small"
        onClick={copy}
        aria-label={copied ? t('data.copied2') : t('data.copyRunId')}
        sx={{ p: 0.25, color: copied ? themeTokens.positive : themeTokens.iconMuted }}
      >
        {copied ? <CheckIcon sx={{ fontSize: 13 }} /> : <ContentCopyIcon sx={{ fontSize: 13 }} />}
      </IconButton>
    </Box>
  );
}
